import vanillaToast from 'vanilla-toast';
import getPageName from './getPageName';

const form = () => {
  const crmRequest = 'https://sigmaedu.ru/sigmaeng/handler.php';

  const SCORES = {
    Age: {
      '21 or younger': 0,
      '22 – 25': 1,
      '26 – 31': 1,
      '32 or older': 1
    },
    Employment: {
      'Student': 0,
      'Unemployed': 0,
      'Entry-level specialist': 1,
      'Middle+ specialist': 1,
      'Individual entrepreneur': 1
    },
    EnglishLevel: {
      'Elementary / Pre-Intermediate': 0,
      Intermediate: 1,
      'Upper-Intermediate or over': 1
    },
    AvailabilityDevices: {
      'laptop/PC': 1,
      'Smartphone only': 0,
      'No laptop/PC, no smartphone': 0
    },
    LevelOfEducation: {
      'Secondary education': 1,
      'Higher education': 1,
      'No education': 0,
      'Primary': 0
    },
  };

  // Установка маски на телефон
  class Phone {
    constructor(options) {
      this.$el = document.querySelector(options.id);
      this.iti = options.iti;
    }

    setupMaskPhone() {
      if (this.$el) {
        this.iti = window.intlTelInput(this.$el, {
          separateDialCode: true,
          initialCountry: 'auto',
          geoIpLookup: function (callback) {
            fetch('https://ipapi.co/json')
              .then(function (res) {
                return res.json();
              })
              .then(function (data) {
                if (data.country_code == 'RU') {
                  if (getPageName() == "dataanalyst-uae") {
                    callback('ae');
                  } else {
                    callback('ke');
                  }
                } else {
                  callback(data.country_code);
                }
              })
              .catch(function () {
                if (getPageName() == "dataanalyst-uae") {
                  callback('ae');
                } else {
                  callback('ke');
                }
              });
          },
          utilsScript: '/js/utils.js',
        });

        const setIntervalStartPlaceholder = setInterval(() => {
          let placeholderInputPhone = this.$el.placeholder;

          if (placeholderInputPhone != '') {
            let maskNumber = placeholderInputPhone.replace(/[0-9+]/gi, '9');

            $(this.$el).mask(maskNumber, { autoclear: false });

            clearInterval(setIntervalStartPlaceholder);
          }
        }, 500);

        this.$el.addEventListener('countrychange', function () {
          let placeholderInputPhone = document.getElementById(
            this.id
          ).placeholder;
          let maskNumber = placeholderInputPhone.replace(/[0-9+]/gi, '9');

          $('#' + this.id).mask(maskNumber, { autoclear: false });
        });
      }
    }
  }

  const phone = new Phone({
    iti: 'itiPhone',
    id: '#phone',
  });
  phone.setupMaskPhone(); 

  const phoneSpecial = new Phone({
    iti: 'itiPhoneHome',
    id: '#phone-special',
  });
  phoneSpecial.setupMaskPhone();

  /* Валидаторы */
  var validators = {
    requried: function (value, error) {
      if (!value || value.length === 0) {
        error.message = 'This field is required';
        return false;
      } else {
        return true;
      }
    },
    email: function (value, error) {
      if (/.+@.+\..+/.test(value)) {
        return true;
      } else {
        error.message = 'Incorrect email';
        return false;
      }
    },
    phone: function (status, error) {
      if (status) {
        return true;
      } else {
        error.message = 'Please enter the correct number';
        return false;
      }
    },
  };

  // Показ ошибок при заполнении формы
  function showError(error, field) {
    if (error.message) {
      var errorContainer = document.createElement('div');
      errorContainer.textContent = error.message;
      errorContainer.classList.add('form__error-container');
      field.appendChild(errorContainer);
    }
  }

  // Валидация формы
  function validate(form) {
    var result = true;
    Array.from(form.querySelectorAll('.form__field')).forEach(function (
      formField
    ) {
      var error = {};
      var control = formField.querySelector('select, input, textarea');
      if (formField.querySelector('.form__required')) {
        if (!validators.requried(control.value, error)) {
          showError(error, formField);
          control.classList.add('form__field--invalid');
          result = false;
          return;
        }
      }

      if (control.id === 'email') {
        if (!validators.email(control.value, error)) {
          showError(error, formField);
          control.classList.add('form__field--invalid');
          result = false;
        }
      }

      if (control.id === 'phone') {
        if (!validators.phone(phone.iti.isValidNumber(), error)) {
          showError(error, formField);
          control.classList.add('form__field--invalid');
          result = false;
        }
      }

      if (control.id === 'phone-special') {
        if (!validators.phone(phoneSpecial.iti.isValidNumber(), error)) {
          showError(error, formField);
          control.classList.add('form__field--invalid');
          result = false;
        }
      }

      let invalidField = form.querySelector('.form__field--invalid');
      if (invalidField) {
        invalidField.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    });

    return result;
  }

  // Кастомное сообщение для поля email
  const emailInputs = document.querySelectorAll("input[type=email]");
  
  if (emailInputs.length) {
    emailInputs.forEach((input) => {
      input.addEventListener("invalid", () => {
        input.setCustomValidity(`The email address must contain the '@' symbol. The '@' symbol is missing in the address '${input.value}'.`);
      });

      input.addEventListener("input", () => {
        input.setCustomValidity("");
      });
    })
  }

  // Удаление ошибок с формы
  function deleteErrors(form) {
    form.querySelectorAll('.form__error-container').forEach(function (el) {
      el.remove();
    });

    form.querySelectorAll('.form__field--invalid').forEach(function (el) {
      el.classList.remove('form__field--invalid');
    });
  }

  // Установка формы
  function setForm(selector) {
    var form = document.querySelector(selector);

    if (!form) {
      return;
    }

    form.addEventListener('submit', function (e) {
      sendFormEng(form, e);
    });

    addMaxLengthPromocode(form);

    onFormFilling(form, () => {
      fbq('track', 'InitiateCheckout');
    });
  }

  // Максимальное число символов для поля "Промокод"
  function addMaxLengthPromocode(form) {
    const promocode = form.querySelector('#promocode');
    if (promocode) {
      promocode.setAttribute('maxlength', '30');
    }
  }

  /* Получение данных с форм в модальных окнах */
  function getFormModalData(formClass) {
    const forms = document.querySelectorAll(formClass);

    let data = {};
    [...forms].forEach((form) => {
      Array.from(new FormData(form)).forEach(function (formElement) {
        let key = formElement[0];
        let value = formElement[1];

        data[key] = value;
      });

      form.reset();
    });

    return data;
  }

  /* Переключение и отправка формы в Квизе */
  function quizForm() {
    const slides = document.querySelectorAll('.quiz__slide'),
      submit = document.getElementById('quiz-btn');

    if (slides.length < 1) {
      return;
    }

    submit.addEventListener('click', (e) => {
      let target = e.target,
        form = target.closest('.quiz__slide-form');

      e.preventDefault();
      deleteErrors(form);

      if (validate(form)) {
        sendFormEng(form, e, getFormModalData('.quiz__slide-form'));
      }
    });
  }

  // Отправка формы
  let firstFormData = {};

  function sendFormEng(form, e, modalData) {
    var sendBtn = form.querySelector(
      'button[type="submit"], input[type="submit"]'
    );
    var data = {};

    if (modalData) {
      data = { ...modalData };
    } else {
      e.preventDefault();
      deleteErrors(form);
      data = {};

      if (!validate(form)) {
        return;
      }
      
      Array.from(new FormData(form)).forEach(function (formElement) {
        var key = formElement[0];
        var value = formElement[1];

        if (key == 'Phone') {
          if (form.id === 'form-special') {
            data[key] = phoneSpecial.iti.getNumber();
          } else {
            data[key] = phone.iti.getNumber();
          }
        } else if (key == 'BirthDate') {
          data[key] = value.split('.').reverse().join('-');
        } else {
          data[key] = value;
        }
      });
    }

    sendBtn.disabled = true;

    var url = document.location.href;

    var paramsStartIndex = url.indexOf('?');
    if (paramsStartIndex > -1) {
      url
        .slice(paramsStartIndex + 1, url.length)
        .split('&')
        .map(function (utmString) {
          return utmString.split('=');
        })
        .forEach(function (utmMark) {
          var key = utmMark[0];
          key = key[0].toUpperCase() + key.slice(1, key.length);
          var value = utmMark[1];
          value =
            value.indexOf('#') > -1
              ? value.slice(0, value.indexOf('#'))
              : value;
          data[key] = value;
        });
    }

    data['Eng'] = true;
    data['Landing'] = url;

    // Временный костыль для отправки формы
    data['Place'] = "";

    // Roistat
    let roistatCookie = getCookie('roistat_visit');

    if (!!roistatCookie) {
      data['RoistatCookie'] = roistatCookie;
    }

    if (form.id == 'form-first') {
      firstFormData = { ...data };
    }

    if (form.id == 'form-second' || form.id == 'quiz-form') {
      data['Program'] = firstFormData.Program;
      data['FirstName'] = firstFormData.FirstName;
      data['Email'] = firstFormData.Email;
      data['Phone'] = firstFormData.Phone;
      data['Package'] = firstFormData.Package;
      data['Promocode'] = firstFormData.Promocode;
      data['Place'] = firstFormData.Place;
    }

    /* Передача ClientId */
    (() => {
      let ym_uid = getCookie('_ym_uid');

      if (ym_uid) {
        data['ClientId'] = ym_uid;
      }
    })();

    fetch(crmRequest, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json;charset=utf-8' },
      body: JSON.stringify(data),
    })
      .then(() => {
        sendBtn.disabled = false;
        form.reset();

        if (form.id == 'form-first') {          
          if (getPageName() == 'dataanalyst-learning') {
            fbq('track', 'CompleteRegistration');
            ym(92965313, 'reachGoal', 'CompleteRegistration');
            window.lintrk('track', { conversion_id: 16830722 });
            vanillaToast.success(
              'Your application was successfully sent<br> Success!',
              { duration: 3000, fadeDuration: 500 }
            );
            openSuccessModalEng(data['Program']);
            return;
          }

          if (getPageName() == 'dataanalytics') {
            ym(92965313,'reachGoal','TestForm');
          }

          fbq('track', 'Lead');
          ym(92965313, 'reachGoal', 'Lead');
          gtag('event', 'first_form');
          window.lintrk('track', { conversion_id: 16830714 });
          if (document.querySelector('.form__steps')) {
            document.querySelector('.form__steps').classList.add('first');
            document.getElementById('form-first').style.display = 'none';
            document.getElementById('form-second').style.display = 'block';
          }

          //Изменение текста в левой части формы во втором шаге
          if (getPageName() == 'dataanalyst' || getPageName() == 'learn-dataanalyst' || getPageName() == 'power-bi') {
            document.querySelector(
              '.form__second-toggle-dataanalyst'
            ).style.display = 'block';
            document.querySelector('.form__first-toggle').style.display =
              'none';
          }

          // Открытие квиза
          if (getPageName() == 'dataanalyst-bootcamp') {
            document.querySelector('.quiz').classList.add('is-active');
            document.querySelector('body').classList.add('scroll-lock');
            document
              .querySelector('.quiz__header-close')
              .addEventListener('click', () => {
                document.querySelector('.quiz').classList.remove('is-active');
                document.querySelector('body').classList.remove('scroll-lock');
              });
          }
        }

        if (form.id == 'form-second') {
          fbq('track', 'CompleteRegistration');
          ym(92965313, 'reachGoal', 'CompleteRegistration');
          window.lintrk('track', { conversion_id: 16830722 });
          vanillaToast.success(
            'Your application was successfully sent<br> Success!',
            { duration: 3000, fadeDuration: 500 }
          );
          // openSuccessModalEng(data['Program']);
          document.querySelector('.form__steps').classList.remove('first');
          document.querySelector('.form__steps').classList.add('second');
        }

        if (form.id == 'form-special'){
          openSuccessModalEng(data['Program']);
          fbq('track', 'Lead');
          ym(92965313, 'reachGoal', 'Lead');
        }

        if (form.id == 'quiz-form') {
          const quizSlides = document.querySelectorAll('.quiz__slide');
          fbq('track', 'CompleteRegistration');
          ym(92965313, 'reachGoal', 'CompleteRegistration');
          window.lintrk('track', { conversion_id: 16830722 });
          vanillaToast.success(
            'Your application was successfully sent<br> Success!',
            { duration: 3000, fadeDuration: 500 }
          );
          document.querySelector('.quiz').classList.remove('is-active');
          document.querySelector('body').classList.remove('scroll-lock');
          quizSlides[quizSlides.length - 1].style.display = 'none';
          quizSlides[0].style.display = 'flex';
          documentDownLoad(
            '/files/10_useful_materials_for_a_future_Data_Analyst.pdf',
            '10_useful_materials_for_a_future_Data_Analyst.pdf'
          );
        }

        if (form.id == 'form-partnership') {
          vanillaToast.success(
            'Your application was successfully sent<br> Success!',
            { duration: 3000, fadeDuration: 500 }
          );
          openSuccessModalPartnership();
        }

        // AB              
        amountScores(data);

        // Отправка в АМО 
        if (data['Program'] === "QA Engineer") {
          formSubmitCommerce(data);          
        }
        formSubmtNewLink(data, form);
      })
      .catch((err) => {
        sendBtn.disabled = false;
        vanillaToast.error(
          'Please check your network connection or try again later<br> There has been an error',
          { duration: 3000, fadeDuration: 500 }
        );

        console.log(err);
      });
  }

  function formSubmitCommerce(data) {
    const requestUrl = "https://hook.eu2.make.com/kblmrpcfjexpkw72sfgomxariz67ogk8";
    $.ajax({
      url: requestUrl,
      method: 'POST',
      contentType: 'application/json;charset=utf-8',
      data: JSON.stringify(data),
      success: function () {},
      error: function () {},
    });
  }

  function formSubmtNewLink(data, form) {
    $.ajax({
      url: "https://hook.eu2.make.com/bl15odssio5yallvqirraeqgcoulb5fb",
      method: 'POST',
      contentType: 'application/json;charset=utf-8',
      data: JSON.stringify(data),
      success: function () {
        formSubmitBizavtomat(data, form);
      },
      error: function () {        
        formSubmitBizavtomat(data, form);
      },
    });
  }

  function formSubmitBizavtomat(data, form) {
    $.ajax({
      url: "https://n8n.bizavtomat.ru/webhook/62da461e-8135-47f0-9e40-a546cb15d125",
      method: 'POST',
      contentType: 'application/json;charset=utf-8',
      data: JSON.stringify(data),
      success: function () {
        if (form.id == 'form-second' || getPageName() == 'dataanalytics') {
          setTimeout(() => {
            window.location.assign("https://wa.me/+254703246117/");
          }, 0);          
        }
      },
      error: function () {},
    });
  }

  //Скачивание документа при нажатии на кнопку модального окна при успешной отправке формы
  function documentDownLoad(path, filename) {
    const a = document.createElement('a');
    a.href = path;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // Модальное окно успешно отправленной формы
  function successModal() {
    let modal = document.querySelector('#quiz-success');

    if (!modal) {
      modal = document.createElement('div');
      ['modal', 'quiz'].forEach((additionalClass) => {
        modal.classList.add(additionalClass);
      });
      modal.id = 'quiz-success';
      modal.innerHTML = '<div class="quiz__content"></div>';

      document.body.append(modal);
    }

    const a = document.createElement('a');
    a.href = '#quiz-success';
    a.rel = 'modal:open';
    a.style.display = 'none';
    document.body.append(a);

    window.openSuccessModalEng = (programName) => {
      const successModal = document.createElement('div');
      successModal.classList.add('beat');

      /* FLOW-9732 замена текста в зависимости от дня недели и времени */
      let text = '';

      (() => {
        const date = new Date();

        if (programName === 'I haven’t chosen yet, need a consultation') {
          text = 'Our team will call you back to&nbsp;help you choose a&nbsp;bootcamp that suits you best.';
        } else if (date.getDay() == 0 || date.getDay() == 6) {
          text = 'Our team will reach out to you <b>on Monday.</b>';
        } else if (date.getHours() >= 18) {
          text = 'Our team will reach out to you <b>tomorrow.</b>';
        } else if (programName === 'Data Analyst' || programName === 'QA Engineer') {
          text =
            'Our team will be&nbsp;calling you from <b>+254&nbsp;711&nbsp;019&nbsp;500</b> to&nbsp;discuss your online course enrollment from 11:00 to&nbsp;20:00.';
        } else {
          text = 'Our team will contact you upon group formation.';
        }
      })();

      if (programName === 'Data Analyst') {
        successModal.innerHTML = `
          <div class="container">
            <div class="beat__inner">
              <div class="beat__image">
                <img src="/img/main/form/dataanalyst.png" width="207" height="268" loading="lazy" alt="Image of phone">
              </div>
              <div class="beat__info">                
                <h2>Thank you for choosing Sigma Academy!</h2>
                <p class="beat__note"><b>Your application is&nbsp;accepted!</b><br> Our team will be&nbsp;calling you from <b>+254&nbsp;711&nbsp;019&nbsp;500</b><br>to&nbsp;discuss your data bootcamp enrollment from 11:00 to&nbsp;20:00.</p>
                <p class="beat__note"><b>Join our Telegram Bot to&nbsp;get all the guidance and support you need:</b></p>
                <ul class="beat__list">
                  <li>&#149;&nbsp;Get advice on&nbsp;enrolling in&nbsp;the bootcamp</li>
                  <li>&#149;&nbsp;Access our useful webinar <strong>&quot;Boost Your Income: Key Skills for Digital Professions&quot;</strong>, and more!</li>
                </ul>
                <p class="beat__note"><b>Bonus &laquo;10&nbsp;useful materials for a&nbsp;future Data Analyst&raquo;<br> will be&nbsp;automatically downloaded.</b></p>
                <a class="beat__button btn" href="https://t.me/Sigma_Kenya_bot" target="_blank" rel="nofollow noopener noreferrer" onclick="gtag('event', 'tg_after_form');" style="margin-top: 1.875rem">Get a&nbsp;bonus</a>
              </div>
              <button class="beat__close" aria-label="Close" type="button"></button>
            </div>
          </div>
        `;
      } else if (programName === 'QA Engineer') {
        successModal.innerHTML = `
          <div class="container">
            <div class="beat__inner">
              <div class="beat__image">
                <img src="/img/main/form/dataanalyst.png" width="207" height="268" loading="lazy" alt="Image of phone">
              </div>
              <div class="beat__info">                
                <h2>Thank you for choosing Sigma Academy!</h2>
                <p class="beat__note"><b>Your application is&nbsp;accepted!</b><br> Our team will be&nbsp;calling you from <b>+254&nbsp;711&nbsp;019&nbsp;500</b><br>to&nbsp;discuss your QA engineering bootcamp enrollment from 11:00 to&nbsp;20:00.</p>
                <p class="beat__note"><b>Join our Telegram Bot to&nbsp;get all the guidance and support you need:</b></p>
                <ul class="beat__list">
                  <li>&#149;&nbsp;Get advice on&nbsp;enrolling in&nbsp;the bootcamp</li>
                  <li>&#149;&nbsp;Access our useful webinar <strong>&quot;Boost Your Income: Key Skills for Digital Professions&quot;</strong>, and more!</li>
                </ul>
                <a class="beat__button btn" href="https://t.me/Sigma_Kenya_bot" target="_blank" rel="nofollow noopener noreferrer" onclick="gtag('event', 'tg_after_form');" style="margin-top: 1.875rem">Get a&nbsp;bonus</a>
              </div>
              <button class="beat__close" aria-label="Close" type="button"></button>
            </div>
          </div>
        `;
      }
      else if (programName === 'Smart Personal Investments') {
        successModal.innerHTML = `
          <div class="container">
            <div class="beat__inner">
              <div class="beat__image">
                <img src="/img/main/form/dataanalyst.png" width="207" height="268" loading="lazy" alt="Image of phone">
              </div>
              <div class="beat__info">                
                <h2>Thank you for choosing Sigma Academy!</h2>
                <p class="beat__note"><b>Your application is&nbsp;accepted!</b><br> Our team will be&nbsp;calling you from <b>+254&nbsp;711&nbsp;019&nbsp;500</b><br>to&nbsp;discuss your bootcamp enrollment from 11:00 to&nbsp;20:00.</p>
                <p class="beat__note"><b>Join our Telegram Bot to&nbsp;get all the guidance and support you need:</b></p>
                <ul class="beat__list">
                  <li>&#149;&nbsp;Get advice on&nbsp;enrolling in&nbsp;the bootcamp</li>
                  <li>&#149;&nbsp;Access our useful webinar <strong>&quot;Boost Your Income: Key Skills for Digital Professions&quot;</strong>, and more!</li>
                </ul>
                <a class="beat__button btn" href="https://t.me/Sigma_Kenya_bot" target="_blank" rel="nofollow noopener noreferrer" onclick="gtag('event', 'tg_after_form');" style="margin-top: 1.875rem">Get a&nbsp;bonus</a>
              </div>
              <button class="beat__close" aria-label="Close" type="button"></button>
            </div>
          </div>
        `;
      }
      else if (programName === 'Power BI Specialist') {
        successModal.innerHTML = `
          <div class="container">
            <div class="beat__inner">
              <div class="beat__image">
                <img src="/img/main/form/dataanalyst.png" width="207" height="268" loading="lazy" alt="Image of phone">
              </div>
              <div class="beat__info">                
                <h2>Thank you for choosing Sigma Academy!</h2>
                <p class="beat__note"><b>Your application is&nbsp;accepted!</b><br> Our team will be&nbsp;calling you from <b>+254&nbsp;711&nbsp;019&nbsp;500</b><br>to&nbsp;discuss your course enrollment from 11:00 to&nbsp;20:00.</p>
                <p class="beat__note"><b>Join our Telegram Bot to&nbsp;get all the guidance and support you need:</b></p>
                <ul class="beat__list">
                  <li>&#149;&nbsp;Get advice on&nbsp;enrolling in&nbsp;the course</li>
                  <li>&#149;&nbsp;Access our useful webinar <strong>&quot;Boost Your Income: Key Skills for Digital Professions&quot;</strong>, and more!</li>
                </ul>
                <a class="beat__button btn" href="https://t.me/Sigma_Kenya_bot" target="_blank" rel="nofollow noopener noreferrer" onclick="gtag('event', 'tg_after_form');" style="margin-top: 1.875rem">Get a&nbsp;bonus</a>
              </div>
              <button class="beat__close" aria-label="Close" type="button"></button>
            </div>
          </div>
        `;
      } else {
        successModal.innerHTML = `
        <div class="container">
            <div class="beat__inner">
              <div class="beat__image">
                <img src="/img/main/form/beat.webp" width="207" height="268" loading="lazy" alt="Image of phone">
              </div>
              <div class="beat__info">
                <h2>Thank you for choosing Sigma Academy!</h2>
                <p class="beat__note">Your application is&nbsp;accepted!<br> ${text}</p>
                <p class="beat__note">Meanwhile, you might also want to check our <a href="/program/dataanalyst"><b>Data&nbsp;Analyst Bootcamp</b></a> program. Start on&nbsp;January&nbsp;25th!</p>
                <p class="beat__note"><b>Join our Telegram Bot to&nbsp;get all the guidance and support you need:</b></p>
                <ul class="beat__list">
                  <li>&#149;&nbsp;Get advice on&nbsp;enrolling in&nbsp;the bootcamp</li>
                  <li>&#149;&nbsp;Access our useful webinar <strong>&quot;Boost Your Income: Key Skills for Digital Professions&quot;</strong>, and more!</li>
                </ul>
                <a class="beat__button btn" href="https://t.me/Sigma_Kenya_bot" target="_blank" rel="nofollow noopener noreferrer" onclick="gtag('event', 'tg_after_form');">Get a&nbsp;bonus</a>
                
              </div>
              <button class="beat__close" aria-label="Close" type="button"></button>
            </div>
          </div>
        `;
      }

      document.body.append(successModal);
      document.body.classList.add('scroll-lock');
      const closeButton = successModal.querySelector('.beat__close');

      //Скачивание файла лид магнита при нажатии на кнопку модального окна при успешной отправке формы программы dataanalyst
      if (programName === 'Data Analyst') {
        const buttonClick = document.querySelector('.beat__button');
        buttonClick.addEventListener('click', () => {
          documentDownLoad(
            '/files/10_useful_materials_for_a_future_Data_Analyst.pdf',
            '10_useful_materials_for_a_future_Data_Analyst.pdf'
          );
        });
      }

      const onOverlayClick = (evt) => {
        if (!evt.target.closest('.beat__inner')) {
          document.body.classList.remove('scroll-lock');
          document.body.removeChild(successModal);
          document.body.removeEventListener('click', onOverlayClick);
        }
      };

      document.body.addEventListener('click', onOverlayClick);
      closeButton?.addEventListener('click', () => {
        document.body.classList.remove('scroll-lock');
        document.body.removeChild(successModal);
        document.body.removeEventListener('click', onOverlayClick);
      });
    };

    window.openSuccessModalPartnership = () => {
      const successModal = document.createElement('div');
      successModal.classList.add('beat');
      successModal.innerHTML = `
        <div class="container">
          <div class="beat__inner">
            <div class="beat__image">
              <img src="/img/main/form/beat-alt.webp" width="207" height="268" loading="lazy" alt="Image of phone">
            </div>
            <div class="beat__info">                
              <h2>Thank you for choosing Sigma Academy!</h2>
              <p class="beat__note">We&rsquo;re excited to&nbsp;learn more about your business and how we&nbsp;can help you achieve your goals. We&rsquo;ll be&nbsp;in&nbsp;touch shortly to&nbsp;discuss your application</p>
            </div>
            <button class="beat__close" aria-label="Закрыть окно" type="button"></button>
          </div>
        </div>
      `;

      document.body.append(successModal);
      document.body.classList.add('scroll-lock');
      const closeButton = successModal.querySelector('.beat__close');

      const onOverlayClick = (evt) => {
        if (!evt.target.closest('.beat__inner')) {
          document.body.classList.remove('scroll-lock');
          document.body.removeChild(successModal);
          document.body.removeEventListener('click', onOverlayClick);
        }
      };

      document.body.addEventListener('click', onOverlayClick);
      closeButton.addEventListener('click', () => {
        document.body.classList.remove('scroll-lock');
        document.body.removeChild(successModal);
        document.body.removeEventListener('click', onOverlayClick);
      });
    };
  }

  // Отслеживание заполнения формы
  function onFormFilling(form, callback) {
    const controls = form.querySelectorAll('input, select, textarea');
    let changed = false;
    controls.forEach((control) => {
      $(control).one('blur', (e) => {
        if (!changed) {
          callback(e);
          changed = true;
        }
      });
    });
  }

  /* Получение cookie */
  function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  /* Инициализация селектов */
  function setSelects() {
    const selectors = [
      {
        id: '#ProgramFormEng',
        placeholder: 'Program',
      },
      {
        id: '#gender',
        placeholder: 'Gender',
      },
      {
        id: '#PreferredLearningFormat',
        placeholder: 'Preferred learning format',
      },
      {
        id: '#PreferredPaymentOption',
        placeholder: 'Preferred payment option',
      },
      {
        id: '#availability',
        placeholder: 'Availability of a laptop/computer',
      },
      {
        id: '#englishLevel',
        placeholder: 'Level of English',
      },
      {
        id: '#MonthlyIncome',
        placeholder: 'Monthly income',
      },
      {
        id: '#LevelOfEducation',
        placeholder: 'Level of education',
      },
      {
        id: '#Age',
        placeholder: 'Age',
      },
      {
        id: '#Package',
        placeholder: 'Package',
      },
      {
        id: '#PurposeTraining',
        placeholder: 'What is the purpose of training',
      },
      {
        id: '#Employment',
        placeholder: 'Your current occupation and employment',
      },
      {
        id: '#FoundUs',
        placeholder: 'How did you know about us',
      },
    ];

    selectors.forEach((item) => {
      let selector = $(item.id),
        message = '';

      selector.select2({
        placeholder: item.placeholder,
        language: {
          noResults: function () {
            return message;
          },
        },
        escapeMarkup: function (markup) {
          return markup;
        },
      });

      selector.val(null).trigger('change');
    });
  }

  /* Сумма баллов для опредения качества заявки */
  function amountScores(data) {
    if (data.Age && data.Employment && data.EnglishLevel && data.AvailabilityDevices && data.LevelOfEducation) {      
      try {
        let sum =
        SCORES.Age[data.Age] +
        SCORES.Employment[data.Employment] +
        SCORES.EnglishLevel[data.EnglishLevel] +
        SCORES.AvailabilityDevices[data.AvailabilityDevices] +
        SCORES.LevelOfEducation[data.LevelOfEducation];

        if (sum == 5) {
          ym(92965313,'reachGoal','Segment_AB');
          fbq('track', 'Schedule');
        }      
      } catch(e) {
        console.log(e);
      }      
    }
  }

  /* Добавления поля Package на главной странице в форме */
  function addFieldPackage() {
    const Programs = document.getElementById('ProgramFormEng');

    if (!Programs) {
      return;
    }

    const PackageField = document.createElement('div');
    PackageField.classList.add('form__field', 'formSelect');    

    Programs.onchange = () => {
      if (Programs.selectedIndex != '-1') {
        let program = Programs.options[Programs.selectedIndex].getAttribute('program');

        if (program == 'dataanalyst' || program == 'webdeveloper' || program == 'power-bi') {
          Programs.parentElement.after(PackageField);
          if (program == 'dataanalyst' || program == 'power-bi') {
            PackageField.innerHTML = `
              <select class="form__select" name="Package" id="Package">
                <option value="Light">Light</option>
                <option value="Standard">Standard</option>
                <option value="Premium"> Premium</option>
                <option value="Advanced Premium"> Advanced Premium</option>
                <option value="I haven’t chosen yet, need a consultation">I haven’t chosen yet, need a consultation</option>
              </select>
              <span class="form__required"></span>
            `;
          } else {
            PackageField.innerHTML = `
              <select class="form__select" name="Package" id="Package">
                <option value="Light">Light</option>
                <option value="Full"> Full</option>
              </select>
              <span class="form__required"></span>
            `;
          }

          const Package = $('#Package');
          Package.select2({
            placeholder: 'Package',
          });
          Package.val(null).trigger('change');
        } else {
          const Package = document.getElementById('Package');

          if (Package) {
            Package.parentElement.remove();
          }
        }
      }
    };
  }

  /* Инициализация функций */
  $(function () {
    setForm('#form-first');
    setForm('#form-second');
    setForm('#form-partnership');
    setForm('#form-special');
    setSelects();
    successModal();
    addFieldPackage();
    quizForm();

    /* Добавления поля инпута при выборе в форме опроса значения "Other (your answer)" */
    const PurposeTraining = document.getElementById('PurposeTraining'),
      PurposeTrainingRadios = document.querySelectorAll(
        '.quiz input[name="PurposeTraining"]'
      ),
      PurposeTrainingText = document.getElementById('PurposeTrainingText'),
      FoundUs = document.getElementById('FoundUs'),
      FoundUsRadios = document.querySelectorAll('.quiz input[name="FoundUs"]'),
      FoundUsText = document.getElementById('FoundUsText');

    if (PurposeTraining) {
      PurposeTraining.onchange = (e) => {
        let value = e.target.value;

        if (value === 'Other (your answer)') {
          PurposeTrainingText.parentNode.style.display = 'block';
          PurposeTrainingText.parentNode.querySelector('.form__input--hidden').classList.add("form__required");
        } else {
          PurposeTrainingText.parentNode.style.display = 'none';
          PurposeTrainingText.parentNode.querySelector('.form__input--hidden').classList.remove("form__required");
        }
      };
    }

    if (PurposeTrainingRadios.length) {
      PurposeTrainingRadios.forEach((radio) => {
        radio.onchange = (e) => {
          let value = e.target.value;

          if (value === 'Other (your answer)') {
            PurposeTrainingText.parentElement.style.display = 'block';
          } else {
            PurposeTrainingText.parentElement.style.display = 'none';
          }
        };
      });
    }

    if (FoundUs) {
      FoundUs.onchange = (e) => {
        let value = e.target.value;

        if (value === 'Other (your answer)') {
          FoundUsText.parentNode.style.display = 'block';
          FoundUsText.parentNode.querySelector('.form__input--hidden').classList.add("form__required");
        } else {
          FoundUsText.parentNode.style.display = 'none';
          FoundUsText.parentNode.querySelector('.form__input--hidden').classList.remove("form__required");
        }
      };
    }

    if (FoundUsRadios.length) {
      FoundUsRadios.forEach((radio) => {
        radio.onchange = (e) => {
          let value = e.target.value;

          if (value === 'Other (your answer)') {
            FoundUsText.parentElement.style.display = 'block';
          } else {
            FoundUsText.parentElement.style.display = 'none';
          }
        };
      });
    }
  });
};

export default form;
